<template>
  <div class="no-data-page">
    <el-empty
      :description="'暂无数据'"
    >
    </el-empty>
  </div>
</template>

<script>
export default {
  name: 'NoDataPage',
}
</script>

<style scoped>
.no-data-page {
  padding: 40px 20px;
  text-align: center;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.description {
  color: #909399;
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
}

@media (max-width: 768px) {
  .no-data-page {
    padding: 20px 10px;
    min-height: 200px;
  }
}
</style>
